import PropTypes from 'prop-types';

import useStyles from './ProgressBarRow.styles';

export default function ProgressBarRow(props) {
  const classes = useStyles();
  
  return (
    <div className={classes.row} data-test="ProgressBarRow">
      {props.children}
    </div>
  );
}

ProgressBarRow.propTypes = {
  children: PropTypes.node.isRequired,
};
